import Instance from "../../../../Axios";

// New Actions for the app

const GetCredIntervencoesTotais = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/intervencoesTotais`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_INTERVENCOES_TOTAIS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredIntervencoesTotais;